import React from "react";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import Section from "../Section";
import FeaturesSectionStyle2 from "../Section/FeaturesSection/FeaturesSectionStyle2";
import AwardSectionStyle2 from "../Section/AwardSection/AwardSectionStyle2";
import { pageTitle } from "../../helpers/PageTitle";
const featureListData = [
  {
    title: "Our Mission",
    subTitle:
      "To empower clinicians with scientifically validated, rational, and safe therapeutic solutions that improve outcomes in chronic neurological, psychiatric and lifestyle-related diseases.",
    iconUrl: "images/icons/professional.svg",
  },
  {
    title: "Our Vision",
    subTitle:
      "To become a trusted and respected healthcare partner by delivering integrity-driven innovation, continuous medical education, and patient-centric care.",
    iconUrl: "images/icons/comprehensive.svg",
  },
  {
    title: "Our Core Values",
    subTitle:
      "We believe in treating each patient as an individual, and we take the time to understand your unique health needs and concerns.",
    iconUrl: "images/icons/patient.svg",
  },
];
const awardData = [
  { iconUrl: "/images/icons/cognivance.png", title: "Cognivance" },
  { iconUrl: "/images/icons/rozucel.png", title: "Rozucel Gold" },
  { iconUrl: "/images/icons/alzavia.png", title: "Alzavia M5/M10" },
  { iconUrl: "/images/icons/pregacel.png", title: "Pregacel-NT" },
  { iconUrl: "/images/icons/solvira.png", title: "Solvira 10/20" },
  { iconUrl: "/images/icons/migrenta.png", title: "Migrenta" },
  { iconUrl: "/images/icons/riventra.png", title: "Riventra" },
];
export default function About() {
  pageTitle("About");
  return (
    <>
      {" "}
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.jpg"
        imgUrl="/images/about/banner_img.png"
        title="About Us"
        subTitle="Life beyond limits"
      />{" "}
      <Section topMd={175} topLg={125} topXl={85} bottomMd={100} bottomLg={110}>
        {" "}
        <FeaturesSectionStyle2
          imgUrl="images/about/About-us.png"
          data={featureListData}
        />{" "}
      </Section>{" "}
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        {" "}
        <AwardSectionStyle2
          sectionTitle="About Celbion Healthcare"
          sectionSubTitle="Welcome to Celbion Healthcare, a pharmaceutical company dedicated to improving health and well-being through dependable and accessible medicines. Since the start of our journey, we have focused on delivering products that meet the highest standards of quality, affordability, and trust—empowering patients to live healthier, more fulfilling lives.<br /><br /> Every step we take is carefully planned with the aim of making a meaningful impact on human health and establishing Celbion Healthcare as a focused, specialty-driven branded pharmaceutical organization within the Indian healthcare ecosystem. In an ever-evolving healthcare environment, we remain committed to excellence, ensuring superior service while consistently maintaining uncompromised quality and value across our offerings. Driven by shared values and a strong sense of responsibility, we work together to create lasting value for doctors, patients, and our valued business partners."
          data={awardData}
        />{" "}
      </Section>{" "}
    </>
  );
}
